module.exports = __webpack_public_path__ + "images/d4021c0a.png";